export const FOMR_INPUT_REGISTER = ({
  channelBuyList,
  channelBuyType,
  mobileBrandOptions,
  mobileModelOptions,
  selectedProduct,
}) => {
  const span = 24;
  const SCAN_QR = [
    {
      name: 'storeId',
      label: 'รหัสหรือ QRCode โฟกัส shop',
      type: 'INPUT_QR',
      span,
    },
  ];
  const UPLOAD_IMG = [
    {
      name: 'invImage',
      label: 'ถ่ายภาพใบเสร็จ',
      type: 'UPLOAD_TWO',
      span: 12,
      rules: {
        required: {
          value: true,
          message: 'ถ่ายภาพใบเสร็จ',
        },
      },
    },
    {
      name: 'packageImage',
      label: 'ถ่ายภาพสินค้าแพ็คเกจสินค้า',
      type: 'UPLOAD_TWO',
      span: 12,
      rules: {
        required: {
          value: true,
          message: 'ถ่ายภาพสินค้าแพ็คเกจสินค้า',
        },
      },
    },
  ];
  return [
    {
      name: 'warrantyNumberCode',
      label: 'รหัสรับประกัน',
      type: 'INPUT',
      disabled: true,
      span,
    },
    {
      name: 'fullName',
      label: 'ชื่อ-นามสกุล (Name - Surname)',
      type: 'INPUT',
      rules: {
        required: true,
      },
      span,
    },
    {
      name: 'telephone',
      label: 'หมายเลขโทรศัพท์มือถือ (Mobile phone)',
      type: 'INPUT',
      disabled: true,
      span,
    },
    {
      name: 'channelBuyId',
      label: 'ซื้อผ่านช่องทาง (Purchase channel)',
      type: 'DROPDOWN',
      properties: {
        options: channelBuyList || [],
      },
      rules: {
        required: true,
      },
      span,
      disabled: !!selectedProduct,
      style: { width: '100%', height: '100%', minHeight: '32px' },
    },
    ...(channelBuyType === 'FOCUS' || channelBuyType === 'STORE' ? SCAN_QR : []),
    ...(channelBuyType === 'FOCUS' ? UPLOAD_IMG : []),
    {
      name: 'mobileBrandId',
      label: 'ยี่ห้อโทรศัพท์ (Mobile phone brand)',
      type: 'DROPDOWN',
      properties: {
        options: mobileBrandOptions || [],
      },
      rules: {
        required: true,
      },
      span,
      disabled: !!selectedProduct,
      style: { width: '100%', height: '100%', minHeight: '32px' },
    },
    {
      name: 'mobileModelId',
      label: 'รุ่นโทรศัพท์ (Mobile phone model)',
      type: 'DROPDOWN',
      properties: {
        options: mobileModelOptions || [],
      },
      rules: {
        required: true,
      },
      disabled: !!selectedProduct,
      span,
      style: { width: '100%', height: '100%', minHeight: '32px' },
    },
    {
      name: 'text',
      type: 'LABEL',
      span,
    },
  ];
};

export const FORM_COMFIRM = () => {
  return [
    {
      name: 'checkBox',
      label: 'ฉันได้ยอมรับ',
      type: 'CHECKBOX',
      properties: {
        options: [],
      },
      rules: {
        required: true,
      },
      span: 8,
    },
  ];
};
